import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { isTabletOrMobileDevice } from 'constants/app';
import { getIsMarketGraphsDarkThemeEnabled, getMarketGraphIsSmallScreenView } from 'redux/modules/appConfigs/selectors';

import styles from './MarketGraphNoData.module.scss';

type MarketGraphNoDataProps = {
  type: 'chart' | 'liquidity-table' | 'blacklisting';
};

export default function MarketGraphNoData({ type }: MarketGraphNoDataProps) {
  const { t } = useTranslation();

  const isDarkTheme = useSelector(getIsMarketGraphsDarkThemeEnabled);
  const isSmallScreenView = useSelector(getMarketGraphIsSmallScreenView);

  const isMobile = isSmallScreenView || isTabletOrMobileDevice;

  return (
    <div
      className={classNames(styles.noData, {
        [styles.noData__mobile__chart]: isMobile && type === 'chart',
        [styles.noData__mobile__table]: isMobile && type === 'liquidity-table'
      })}
    >
      <i className={classNames('biab_custom-icon-no-data', styles.noData__icon)} />
      <p
        className={classNames(styles.noData__text, {
          [styles.noData__text__mobile]: isTabletOrMobileDevice,
          [styles.noData__text__dark]: isDarkTheme
        })}
      >
        {t('marketGraph.labels.noData')}
      </p>
    </div>
  );
}
